<!--redevelop to web sockets in the future-->
<template>
    <b-alert class="m-0 border-radius-0" variant="success" show v-if="appUpdated">
        New version was released. Please <a href="javascript:;" class="alert-link" @click="reloadApp">click here</a> to refresh the app and avoid any bugs.
    </b-alert>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'auto-reload',
    computed: {
      ...mapState({
        appUpdated: state => state.common.appUpdated,
      }),
    },
    methods: {
      reloadApp(e) {
        window.location.reload(true);
        e.preventDefault();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AutoReload.vue